// Start-month helpers for the Reconciliation page. An account's start month
// is the month of its starting-balance date (opening_balance_date). The mark
// is shown whatever the month's status, so it stays after reconciling.
import { formatMoney } from '../../utils/money';
import { formatCalendarDay } from '../../utils/localDate';

const ym = (v) => (v ? String(v).slice(0, 7) : '');

export const hasStartingBalance = (a) => Boolean(a && a.opening_balance_date);

export const isStartMonth = (a, month) => hasStartingBalance(a) && ym(a.opening_balance_date) === ym(month);

const startAmount = (a) => formatMoney(a.opening_balance ?? 0, a.currency_code);
const startDay = (a) => formatCalendarDay(a.opening_balance_date);

// Under the account name: 'Starts <date> . <amount>', or the first-activity
// month when there is no starting balance.
export const startLine = (a) => {
  if (hasStartingBalance(a)) return `Starts ${startDay(a)} \u00b7 ${startAmount(a)}`;
  if (a && a.first_activity_month) return `Starts ${ym(a.first_activity_month)}`;
  return '';
};

// Appended to a start-month cell tooltip.
export const startTooltip = (a) => ` \u00b7 Start: ${startAmount(a)} as of ${startDay(a)}`;

// PeriodPanel header line for the start month.
export const startingMonthText = (a, month) => (isStartMonth(a, month)
  ? `Starting month \u00b7 starting balance ${startAmount(a)} as of ${startDay(a)}`
  : '');
